/*
 * Every dock panel id, with no React import: the persist reconciler (`~/store/ui/reconcile`) reads this to judge a stored layout before any component loads. `registry.js` keys `PANELS` by these same ids;
 */
export const DOCK_PANEL_IDS = [
	'stage',
	'output',
	'sources',
	'effects',
	'debug',
	'source_props',
	'properties',
	'layers',
	'presets',
	'projects',
	'recordings',
	'images',
	'assets',
]

export const DOCK_PANEL_ID_SET = new Set(DOCK_PANEL_IDS)

// The two monitors: never closed, so a layout without either is not one this dock can restore.
export const MONITOR_IDS = ['stage', 'output']
